import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import {PROTOCOLS} from "../../util/Validations";
import {ASML_ASSET_TYPE} from "../../util/Constants";
import {AsmlDeviceOverviewContext} from "./context/AsmlDeviceOverviewContext";
import CommonDeviceLogstream from "../../commonui/CommonDeviceLogstream";

const AsmlDeviceLogstream = ({intl}) => {
    const {viewModel, dispatch} = useContext(AsmlDeviceOverviewContext);
    const deviceList = [
        viewModel.inductCameraDeviceInformation,
        viewModel.printerDeviceInformation,
        viewModel.verificationCameraDeviceInformation
    ].flatMap(obj => Object.values(obj));

    const props = {
        protocols: PROTOCOLS.ASML,
        dispatch,
        deviceList,
        deviceType: ASML_ASSET_TYPE,
        intl
    }
    return (
        <Column>
            <CommonDeviceLogstream {...props}/>
        </Column>
    );
}

export default injectIntl(AsmlDeviceLogstream)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/AsmlDeviceLogStream.js